module.exports = __webpack_public_path__ + "media/images/athletes/2798-0421ab1878df262283b7ac9d35c3e185.png";